export const getBar = ({ title, xData, data }) => ({
  color: ['#3398DB'],
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  },
  grid: {
    left: '5%',
    right: '5%',
    bottom: '7%',
    containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      data: xData,
      axisTick: {
        alignWithLabel: true
      },
      axisLabel: {
        textStyle: {
          color: '#fff'
        }
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#fff'
        }
      }
    }
  ],
  yAxis: [
    {
      type: 'value',
      axisLabel: {
        textStyle: {
          color: '#fff'
        }
      }
    }
  ],
  series: [
    {
      name: title,
      type: 'bar',
      barWidth: '60%',
      data: data
    }
  ]
});

export const getPie = ({ data, title }) => {
  const color = ['#fdae7b', '#FF7C7C', '#fddb7d', '#df7bfd', '#92c8b1'];
  const getTotal = () => data.reduce((sum, e) => (sum += e.value), 0);
  const getProportion = name => {
    const v = data.find(e => e.name === name).value;
    return Math.round((v / getTotal()) * 100) + '%';
  };
  const getIndex = name => data.findIndex(e => e.name === name);
  return {
    color,
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: '5%',
      top: 'center',
      formatter(name) {
        return `{${getIndex(name)}|${name}\n${getProportion(name)}}`;
      },
      textStyle: {
        color: '#fff',
        lineHeight: 18,
        rich: {
          ...color.reduce((map, _, i) => {
            map[i] = { color: color[i], fontSize: '85%' };
            return map;
          }, {})
        }
      },
      itemWidth: 18,
      itemHeight: 18,
      itemGap: 12,
      verticalAlign: 'top',
      data: data.map(e => e.name)
    },
    series: [
      {
        name: title,
        type: 'pie',
        radius: ['50%', '70%'],
        center: ['70%', '50%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '18',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: data
      }
    ]
  };
};

export const makeChart = ({ title, type, xData, data }) => {
  return {
    pie: getPie,
    bar: getBar
  }[type]({ title, data, xData });
};
